var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSanctionsPortalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 .789A8.3 8.3 0 0 0 .704 9.085c0 4.581 3.714 8.295 8.296 8.295l.156-.001 2.839-7.135c-6.929-3.087-2.976 4.55-10.627.778.327-1.419 1.097-4.612 1.798-5.677 7.756 3.824 3.699-4.006 11.033-.571.112-.159.252-.249.382-.278.28-.062.502.171.349.616l-4.843 12.196c4.067-.533 7.207-4.011 7.207-8.223C17.295 4.503 13.581.789 9 .789h0zm4.909 4.642c-1.27.596-2.038 2.95-1.662 4.178l1.662-4.178z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanctionsPortalIcon);
export default __webpack_public_path__ + "static/media/SanctionsPortalIcon.3a8de4be142fb110b7a66d59bc0c66ad.svg";
export { ForwardRef as ReactComponent };